import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b85984dc&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=b85984dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85984dc",
  null
  
)

export default component.exports